export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/d3-shape/src/array.js
// module id = ../../../../d3-shape/src/array.js
// module chunks = 4